// extracted by mini-css-extract-plugin
export default {"container":"ClientSelector_container__nvfgt","label":"ClientSelector_label__WjXHY"};